import { render, staticRenderFns } from "./assessment-start.vue?vue&type=template&id=36df0d9f&scoped=true&"
import script from "./assessment-start.vue?vue&type=script&lang=js&"
export * from "./assessment-start.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36df0d9f",
  null
  
)

export default component.exports